import { RollingNumber } from './rolling-number';

import { cn } from '@/lib/utils';
import { formatCompactLineCount } from '@/lib/utils/number-formatters';

type DiffLineStatsProps = {
  additions: number;
  deletions: number;
  className?: string;
  animated?: boolean;
  /** Shortens counts from 1,000 up ("7.8k", "12k", "1.2M") and writes deletions with a minus sign. */
  compact?: boolean;
  additionsTestId?: string;
  deletionsTestId?: string;
};

/**
 * Canonical `+additions` / `-deletions` pair. Owns the sign convention and the added/removed
 * colors so diff stats read the same in the inbox, the PR header, and file headers.
 * Font size is inherited from the caller.
 */
export function DiffLineStats({
  additions,
  deletions,
  className,
  animated = false,
  compact = false,
  additionsTestId,
  deletionsTestId,
}: DiffLineStatsProps) {
  const added = `+${compact ? formatCompactLineCount(additions) : additions}`;
  const deleted = compact ? `−${formatCompactLineCount(deletions)}` : `-${deletions}`;
  return (
    <span className={cn('inline-flex items-center gap-1 tabular-nums', className)}>
      <span className="text-emerald-400" data-testid={additionsTestId}>
        {animated ? <RollingNumber value={added} /> : added}
      </span>
      <span className="text-rose-400" data-testid={deletionsTestId}>
        {animated ? <RollingNumber value={deleted} /> : deleted}
      </span>
    </span>
  );
}
